/**
 * Mixing used for common new INVOICE methods and data.
 */
import commonCategoriesMixin from '@/mixins/commonCategories.mixin';
import activeTabMixin from '@/mixins/activeTab.mixin';
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import '@/plugins/baseMixin';
import {
	INVOICE_DATA_STRUCT,
	INVOICE_ITEMS_OPERATION,
	INVOICE_MENUS,
	EXPENSE_TYPE,
	VALIDATION_TYPE,
	INVOICE_ITEMS_ACTION,
	FILENAME_REPORT,
	OUTPUT_FORMAT_EXPORT,
	ERROR_STRING,
	INIT_DATA_CARBON
} from '@/shared/constants';
import { store } from '@/store';
import { getProjectFlags } from '@/cruds/flag.crud';
import _ from 'lodash';
import { getScripts } from '@/cruds/script.crud';
import { expenseReport } from '@/cruds/export.crud';
import {
	getInvoicesItems,
	expenseDematerializationReport,
	getSpecificExpense,
	newExpense,
	deleteMyExpense,
	deleteExpense as deleteExpenseItem,
	deleteExpenses,
	passExpenseToOcr,
	updateExpense,
	validateMultipleExpense
} from '@/cruds/expense.crud';
import { getProjectUserExpenseSheet } from '@/cruds/budget.crud';
import { getFileExtension } from '@/shared/helpers';
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import { provideFileDataToUpload } from '@/components/Packages/Captures/capture.utils';

export default {
	mixins: [languageMessages, globalMixin, commonCategoriesMixin, activeTabMixin],
	name: 'invoicesToolsMixin',
	data() {
		return {
			// for error container
			erreur: {},
			warning: '',
			// for tabs display
			canSeeApprove: true,
			// for users list
			userList: [],
			// for selection
			activeDraftAction: false,
			activeApproveAction: false,
			selectedInvoice: [],
			// for modal dialog
			filesUploadInProgress: false,
			openDragAndDropDialog: false,
			openMultipleInvoiceDialog: false,
			dialogMsg: {},
			dragAndDropDialogInfo: {
				title: '',
				closeLabel: '',
				saveLabel: ''
			},
			finalFormDialogInfo: {
				title: '',
				closeLabel: '',
				saveLabel: ''
			},
			multipleInvoiceDialogInfo: {
				title: '',
				closeLabel: '',
				saveLabel: ''
			},
			lineItemsDialogInfo: {
				title: '',
				closeLabel: '',
				saveLabel: ''
			},
			showFinalForm: false,
			showPoDrawDown: false,
			showPoTransaction: false,
			enableFinalSaveBtn: false,
			showDeleteWarning: false,
			messageOnCancel: '',
			isNewProcess: true,
			canEditFinalForm: true,
			finalFormDialogError: '',
			isSavedOnce: false,
			isSaving: false,
			showInvoiceFormError: false,
			showInvoiceDuplicatedAlert: false,
			invoiceDuplicatedAlertMsg: '',
			// invoice data
			invoices: [],
			tempInvoicesFromOcr: [],
			filesToPassThroughOcr: [],
			currentProcessFiles: [],
			currentInvoice: _.cloneDeep(INVOICE_DATA_STRUCT),
			isForSingle: true,
			isWithDetails: false,
			invoiceModeOptions: [],
			finalInvoicePayload: {},
			customFlags: [],
			duplicatedInvoices: [],
			invoiceNoImagesCount: 0,
			draftDataKey: 0,
			// invoice file data
			invoiceParentType: 'expense',
			invoiceParentSubType: 'invoice',
			images: [],
			activeIndexInvoice: 0,
			activeIndexPo: 0,
			// for review mode
			invoicesToReview: [],
			currentIndexToReview: 0,
			isReviewModeLoading: false,
			// for script download
			simpleInvoiceActionTitle: '',
			certifiedInvoiceActionTitle: '',
			invoiceDownloadLabel: '',
			invoiceSendByMailLabel: '',
			isLoadingDownloadInvoice: false,
			isLoadingSendMailInvoice: false,
			isLoadingCertifiedDownloadInvoice: false,
			scriptTypeId: 0,
			isScriptExpenseReportOpen: false,
			scriptsInvoice: [],
			customReport: null,
			// Entry for crew data
			userToEncodedId: null
		};
	},
	computed: {
		...mapGetters({
			taxOptions: 'flag/taxOptions'
		}),
		canEditInvoice() {
			return store.canEditExpense();
		},
		selectedInvoiceHasRefusedItem() {
			return this.selectedInvoice.length > 0 && this.selectedInvoice.some((item) => this.isInvoiceRefused(item));
		},
		dragAndDropMsg() {
			return {
				title: this.dialogMsg.titleNewInvoice,
				closeLabel: this.ableToSwitchFinalForm ? this.dialogMsg.btnCancel : this.dialogMsg.btnClose,
				saveLabel: this.dialogMsg.btnSave
			};
		},
		poDrawdownMsg() {
			return {
				title: this.dialogMsg.titlePoDrawdown,
				closeLabel: this.dialogMsg.btnCancel,
				saveLabel: this.dialogMsg.btnNext
			};
		},
		poTransactionMsg() {
			return {
				title: this.dialogMsg.titlePoTransaction,
				closeLabel: this.dialogMsg.btnCancel,
				saveLabel: this.dialogMsg.btnContinue
			};
		},
		finalFormMsg() {
			return {
				title: this.dialogMsg.titleFinalForm,
				closeLabel: this.dialogMsg.btnCancel,
				saveLabel: this.dialogMsg.btnSave
			};
		},
		initialItemsOperation() {
			if (this.isNewProcess && !this.isWithDetails && this.isForSingle) {
				return INVOICE_ITEMS_OPERATION.MERGE;
			} else return INVOICE_ITEMS_OPERATION.NO_OPERATION;
		},
		maxMobileScreenWidth() {
			return this.$screen.width < 600;
		},
		maxTabletScreenWidth() {
			return this.$screen.width < 768;
		},
		checkInvMandatory() {
			return store.getCurrentProjectConfig().mandatoryInvoiceReceipt;
		},
		getActionsMenu() {
			return this.FormMenu(INVOICE_MENUS.ACTION_ITEMS);
		},
		enableCertified() {
			return store.getCurrentProjectConfig().digitalCertifiedExpense;
		}
	},
	async created() {
		this.invoiceModeOptions = [
			{ text: this.FormMSG(38, 'Single'), value: true },
			{ text: this.FormMSG(39, 'Multiple'), value: false }
		];
		this.dialogMsg = {
			titleNewInvoice: this.FormMSG(9, 'New Invoice'),
			titlePoDrawdown: this.FormMSG(10, 'PO Drawdown'),
			titlePoTransaction: this.FormMSG(11, 'PO Transaction line selection'),
			titleAddInvoice: this.FormMSG(12, 'Add Invoice'),
			titleNewLineItem: this.FormMSG(23, 'New Transaction line'),
			titleEditLineItem: this.FormMSG(24, 'Edit Transaction line'),
			titleFinalForm: this.FormMSG(279, 'View/Edit Invoice'),
			btnClose: this.FormMSG(13, 'Close'),
			btnSave: this.FormMSG(14, 'Save'),
			btnCancel: this.FormMSG(15, 'Cancel'),
			btnNext: this.FormMSG(16, 'Next'),
			btnContinue: this.FormMSG(17, 'Continue'),
			btnUndoChanges: this.FormMSG(42, 'Undo changes'),
			btnSaveAndNext: this.FormMSG(43, 'Save & Next'),
			btnApplyLines: this.FormMSG(18, 'Apply lines'),
			errorNotMatchAmount: this.FormMSG(34, 'The invoice total does not match the transaction line total'),
			errorLinesAmountExceeds: this.FormMSG(35, 'Splitted lines amount exceeds the initial amount total')
		};
		this.messageOnCancel = this.FormMSG(22, 'Are you sure ? All your change will be lost');
		this.simpleInvoiceActionTitle = this.FormMSG(284, 'Simple invoice report');
		this.certifiedInvoiceActionTitle = this.FormMSG(285, 'Certified digital invoice report');
		this.invoiceDownloadLabel = this.FormMSG(286, 'Download this invoice');
		this.invoiceSendByMailLabel = this.FormMSG(287, 'Send me this invoice by Email');

		const projectCustomFlags = await this.getProjectCustomFlags();
		if (projectCustomFlags) this.customFlags = projectCustomFlags;

		// init project categories.
		const initCategory = {
			id: null,
			label: this.FormMSG(71, 'Select a category')
		};
		await this.getCategories(initCategory, EXPENSE_TYPE.INVOICE);

		// initiallize taxOptions for invoices
		this.$nextTick(async () => {
			await this.getTaxOptions();
		});

		// init invoices tabs
		this.initTabs();
	},
	methods: {
		...mapActions({
			getTaxOptions: 'flag/getTaxOptions'
		}),
		invoiceSelectionChange(newSelection, element) {
			this.selectedInvoice = newSelection;
			if (element === 'approve') {
				this.activeApproveAction = newSelection.length > 0;
			} else {
				this.activeDraftAction = newSelection.length > 0;
			}
		},
		saveInvoice() {
			if (this.$refs && this.$refs.invoiceFinalForm) this.$refs.invoiceFinalForm.submitProcess();
		},
		isInvoiceRefused(item) {
			return [VALIDATION_TYPE.REFUSED_LEVEL_1, VALIDATION_TYPE.REFUSED_LEVEL_2].includes(item.validated);
		},
		isStepToFinalFormFulfilled() {
			const invoiceFilesData = this.invoices.map((x) => x.filesData).flat();
			const missingFileType = invoiceFilesData.some((file) => _.isNil(file.type));
			const unprocessedFileExist = this.currentProcessFiles.some((file) => !file.processed);
			if (this.isForSingle) {
				return !missingFileType && !unprocessedFileExist;
			} else {
				return !unprocessedFileExist;
			}
		},
		preventChoiceIfInvoicesNotEmpty(event) {
			if (this.invoices.length > 0) {
				const yesAction = async () => {
					const invoiceIds = this.invoices.map((x) => +x.id);
					try {
						await deleteExpenses(invoiceIds);
					} catch (error) {
						console.log('Error on cancel Process >>>>', error);
					} finally {
						this.currentProcessFiles = [];
						this.invoices = [];
					}
				};
				const noAction = () => {
					this.$nextTick(() => {
						this.isForSingle = !event;
					});
				};
				this.$bvModal
					.msgBoxConfirm(this.FormMSG(46, 'Are you sure about changing modes? the current state of your files will be lost'), {
						title: this.FormMSG(47, 'Please confirm'),
						size: 'md',
						buttonSize: 'sm',
						okVariant: 'danger',
						cancelVariant: 'light',
						okTitle: this.FormMSG(48, 'YES'),
						cancelTitle: this.FormMSG(52, 'NO'),
						hideHeaderClose: false,
						centered: true
					})
					.then(async (v) => {
						if (v) {
							await yesAction();
						} else noAction();
					})
					.catch((err) => {
						console.log('Error on prenvet invoice mode choice >>>>', err);
					});
			}
		},
		async sendForApproval(selectedInvoice) {
			this.invoiceNoImagesCount = 0; // check for error without images when checks mandatory
			let validInvoices = [];
			if (this.checkInvMandatory) {
				this.invoiceNoImagesCount = selectedInvoice.reduce((acc, item) => {
					if (item.documents && item.documents.length <= 0) acc++;
					return acc;
				}, 0);
				validInvoices = selectedInvoice.filter((item) => item.documents.length > 0).map((item) => parseInt(item.id, 10));
			} else {
				validInvoices = selectedInvoice.map((item) => parseInt(item.id, 10));
			}
			try {
				if (validInvoices.length > 0) {
					await validateMultipleExpense(validInvoices, null, true);
					if (this.invoiceNoImagesCount <= 0) {
						this.createToastForMobile(this.FormMSG(30, 'Success'), this.FormMSG(29, 'Sending invoice for approval, Done'));
					} else {
						this.createToastForMobile(
							this.FormMSG(25, 'Error'),
							this.FormMSG(36, 'Some invoices have not been sent due to lack of picture evidence'),
							'',
							'danger'
						);
					}
				} else {
					this.createToastForMobile(
						this.FormMSG(25, 'Error'),
						this.FormMSG(37, 'Invoices not sent for validation due to lack of picture evidence'),
						'',
						'danger'
					);
				}
			} catch (error) {
				console.log('Error on sendForApproval invoice >>>>', error);
				this.createToastForMobile(this.FormMSG(25, 'Error'), this.FormMSG(31, 'Error on Sending invoice for approval'), '', 'danger');
			} finally {
				this.$bus.$emit('invoice:reload-data');
			}
		},
		async approveSelected(invoices) {
			const selectedInteger = invoices.map((item) => parseInt(item.id, 10));
			try {
				await validateMultipleExpense(selectedInteger, null, null);
				this.createToastForMobile(this.FormMSG(30, 'Success'), this.FormMSG(32, 'Validating invoice successfully'));
			} catch (error) {
				console.log('Error on approveSelected invoice >>>>', error);
				this.createToastForMobile(this.FormMSG(25, 'Error'), this.FormMSG(33, 'Error on validating invoice'), '', 'danger');
			} finally {
				this.$bus.$emit('invoice:reload-data');
			}
		},
		showErrorMessage(canSeeError, errorMessage) {
			if (this.$refs && this.$refs.dialogInvoiceDetails) this.$refs.dialogInvoiceDetails.showFormError = canSeeError;
			this.finalFormDialogError = errorMessage === 'default' ? this.dialogMsg.errorNotMatchAmount : errorMessage;
		},
		onShowDragAndDropDialog(isShown) {
			this.openDragAndDropDialog = isShown;
			this.dragAndDropDialogInfo = this.dragAndDropMsg;
			this.showPoTransaction = false;
			this.showPoDrawDown = true;
			this.enableFinalSaveBtn = false;
			this.isWithDetails = false;
			if (!isShown) {
				this.invoices = [];
				this.tempInvoicesFromOcr = [];
				this.filesToPassThroughOcr = [];
				this.currentProcessFiles = [];
				this.setViewerInvoicesImages([]);
				if (this.$refs && this.$refs.dialogInvoiceDetails) {
					this.$refs.dialogInvoiceDetails.poImageUrls = this.providePoImage([], this.$refs.dialogInvoiceDetails.poImageUrls);
				}
				this.currentInvoice = _.cloneDeep(INVOICE_DATA_STRUCT);
				this.isForSingle = true;
			}
		},
		showDragAndDropDialogProcess(isShown, isForEfc = false) {
			this.onShowDragAndDropDialog(isShown);
			if (isShown && isForEfc) this.userToEncodedId = null;
		},
		handleNewInvoice(isForEfc = false) {
			this.isNewProcess = true;
			this.canEditFinalForm = true;
			this.showDragAndDropDialogProcess(true, isForEfc);
		},
		switchFinalForm(singleContext, isNewProcess = false, isReviewMode = false) {
			if (singleContext) {
				this.finalFormDialogInfo = { ...this.finalFormMsg };
			} else {
				this.finalFormDialogInfo = {
					...this.finalFormDialogInfo,
					title: this.dialogMsg.titleFinalForm,
					closeLabel: isReviewMode ? this.dialogMsg.btnClose : this.dialogMsg.btnUndoChanges,
					saveLabel:
						(isReviewMode && this.invoicesToReview.length === this.currentIndexToReview + 1) || !isNewProcess
							? this.dialogMsg.btnSave
							: this.dialogMsg.btnSaveAndNext
				};
				this.openMultipleInvoiceDialog = false;
			}
			if (this.$refs && this.$refs.dialogInvoiceDetails) {
				this.$refs.dialogInvoiceDetails.initializeCarousel();
				this.$refs.dialogInvoiceDetails.showDialog = true;
			}
		},
		switchMultipleInvoice() {
			if (this.$refs && this.$refs.dialogInvoiceDetails) {
				this.$refs.dialogInvoiceDetails.initializeCarousel();
				this.$refs.dialogInvoiceDetails.showDialog = false;
			}
			this.multipleInvoiceDialogInfo = this.dragAndDropDialogInfo;
			this.openMultipleInvoiceDialog = true;
		},
		async switchNextStepInMain() {
			this.tempInvoicesFromOcr = [];
			this.filesToPassThroughOcr = [];
			this.openDragAndDropDialog = false;
			this.currentProcessFiles = [];
			if (this.isForSingle) {
				this.currentInvoice = _.cloneDeep(this.invoices[0]);
				if (this.$refs && this.$refs.dialogInvoiceDetails) {
					if (this.currentInvoice.filesData) {
						this.images = this.currentInvoice.filesData;
						this.$refs.dialogInvoiceDetails.invoiceImageUrls = this.currentInvoice.filesData.map((item) => {
							return item.xid + '.' + item.extension;
						});
					}
					if (this.currentInvoice.purchaseOrders) {
						for (const po of this.currentInvoice.purchaseOrders) {
							for (const document of po.documents) {
								this.$refs.dialogInvoiceDetails.poImageUrls.push(document.xid + '.' + document.ext);
							}
						}
					}
				}
				this.switchFinalForm(true);
			} else {
				await this.multipleSaveLoop();
				this.switchMultipleInvoice();
			}
			this.openDragAndDropDialog = false;
		},
		async nextOrSaveProcess() {
			this.createToastForMobile(this.FormMSG(50, 'Information'), this.FormMSG(49, 'Please verify the data created by OCR'), '', 'info');
			await this.showLoader(this.switchNextStepInMain, 'default-container', false);
		},
		async uploadFile(file) {
			this.setViewerInvoicesImages([file], true);
		},
		setViewerInvoicesImages(filesData, toConcat = false) {
			if (this.$refs && this.$refs.dialogInvoiceDetails && this.$refs.dialogInvoiceDetails.invoiceImageUrls) {
				const { images, imagesUrls } = this.provideInvoiceImage(filesData, this.images, this.$refs.dialogInvoiceDetails.invoiceImageUrls, toConcat);
				this.images = _.cloneDeep(images);
				this.$refs.dialogInvoiceDetails.invoiceImageUrls = _.cloneDeep(imagesUrls);
			}
		},
		provideFinalPayload(invoiceData) {
			const omittedPayload = _.omit(invoiceData, ['documents', 'filesData', 'selectedPo', 'user']);
			this.finalInvoicePayload = _.cloneDeep(omittedPayload);
		},
		async updateInvoice(invoice, itemsOperation = 0) {
			this.isSaving = true;
			this.provideFinalPayload(invoice);
			try {
				const result = await updateExpense(
					this.finalInvoicePayload.id,
					this.finalInvoicePayload,
					this.finalInvoicePayload.expenseItem,
					itemsOperation,
					this.userToEncodedId
				);
				if (result) return { success: true, status: result };
				return { success: false, status: result };
			} catch (error) {
				this.enableFinalSaveBtn = true;
				return { success: false, status: error };
			} finally {
				this.isSaving = false;
				this.finalInvoicePayload = {};
			}
		},
		async multipleSaveLoop() {
			const itemsOperation = this.isWithDetails ? INVOICE_ITEMS_OPERATION.NO_OPERATION : INVOICE_ITEMS_OPERATION.MERGE;
			for (const invoice of this.invoices) {
				await this.updateInvoice(invoice, itemsOperation);
			}
		},
		async nextOrSaveFromFinal(invoice, itemsOperation, isForEfc = false) {
			this.enableFinalSaveBtn = false;
			let isCompleted = false;
			const onSave = await this.updateInvoice(invoice, itemsOperation);
			const { status, success } = onSave;
			const error_509 = status.toString().includes(509);
			if (success) {
				isCompleted = true;
				this.createToastForMobile(this.FormMSG(30, 'Success'), this.FormMSG(55645612, 'Invoice saved successfully.'), '');
			} else {
				if (error_509) {
					this.createToastForMobile(this.FormMSG(500, 'Warning'), this.FormMSG(501, 'No valid contract found for the designed date'), '', 'warning');
				} else {
					this.createToastForMobile(
						this.FormMSG(25, 'Error'),
						this.FormMSG(26, 'An error was occured during saving data. Please contact your administrator.'),
						'',
						'danger'
					);
				}
			}
			if (this.$refs && this.$refs.dialogInvoiceDetails && this.$refs.dialogInvoiceDetails.isReviewMode)
				this.invoicesToReview.splice(this.currentIndexToReview, 1, invoice);
			if (this.isForSingle) {
				if ((isForEfc && isCompleted) || (!isForEfc && isCompleted && (this.isNewProcess || !this.canSeeApprove || this.tabs.activeTabs !== 0))) {
					this.handleFinsihCloseOrCancelProcess('finish', isForEfc);
				} else {
					if (!isForEfc && this.$refs && this.$refs.approveDataView) {
						if (isCompleted) this.isSavedOnce = true;
						this.$refs.approveDataView.initData();
					}
					this.selectedInvoice = _.cloneDeep(invoice);
				}
			} else {
				// update data inside the invoices multiple creation multiple creation table.
				if (isCompleted) {
					const indexOfUpdated = this.invoices.findIndex((x) => +x.id === +invoice.id);
					this.invoices[indexOfUpdated] = _.cloneDeep(invoice);
					if (this.$refs && this.$refs.dialogInvoiceDetails && this.$refs.dialogInvoiceDetails.isReviewMode) {
						const hasNextInvoice = this.invoicesToReview.length > this.currentIndexToReview + 1;
						hasNextInvoice ? this.onPrevOrNext(true) : this.switchMultipleInvoice();
					} else {
						this.switchMultipleInvoice();
					}
				}
			}
		},
		removeInvoicesFromDataView(invoiceIds) {
			this.invoices = this.invoices.filter((x) => !invoiceIds.includes(+x.id));
		},
		async createInvoice() {
			try {
				const newInvoice = await newExpense(EXPENSE_TYPE.INVOICE);
				return newInvoice;
			} catch (error) {
				console.log('Error on newInvoice SINGLE >>>>', error);
				return null;
			}
		},
		async removeFile(index) {
			try {
				const fileObj = this.currentProcessFiles[index];
				const response = await this.$axios.$get(`/removeimage/${fileObj.xid}.${fileObj.extension}`);
				if (ERROR_STRING.ITEM_NOT_FOUND === response)
					this.createToastForMobile(this.FormMSG(25, 'Error'), this.FormMSG(40, 'File not found'), '', 'danger');
				this.currentProcessFiles.splice(index, 1);
			} catch (error) {
				this.createToastForMobile(this.FormMSG(25, 'Error'), this.FormMSG(41, 'Something went wrong'), '', 'danger');
			}
		},
		async onRemoveFiles(fileIndex) {
			await this.removeFile(fileIndex);
			const invoiceToRemove = this.invoices[fileIndex];
			try {
				await deleteMyExpense(invoiceToRemove.id);
			} catch (error) {
				console.log('Error on Deleting Invoice >>>>', error);
			} finally {
				this.invoices.splice(fileIndex, 1);
			}
		},
		fillCurrentProcessFiles(filesData) {
			if (this.currentProcessFiles.length > 0) {
				const nameAlreadyExists = this.currentProcessFiles.map((data) => data.file.name);
				filesData.forEach((data) => {
					if (!nameAlreadyExists.includes(data.file.name)) this.currentProcessFiles.push(data);
				});
			} else this.currentProcessFiles.push(...filesData);
		},
		async saveFile(fileData, parentId) {
			const filesData = await provideFileDataToUpload(fileData.file);
			let formData = new FormData();
			formData.append('uploadimage', filesData.file);
			formData.append('parentType', this.invoiceParentType);
			formData.append('parentSubType', this.invoiceParentSubType);
			formData.append('parentId', +parentId);
			formData.append('fileName', filesData.name);
			formData.append('additionalDocumentType', +fileData.type);

			try {
				const urlStr = process.env.VUE_APP_GQL + '/upload';
				const savedFilesXid = await this.$axios.$post(urlStr, formData, {
					headers: {
						Authorization: `Bearer ${store.state.token}`,
						'content-type': 'multipart/form-data'
					}
				});

				fileData.xid = savedFilesXid.replace(/\.[^\.]*$/, '');
			} catch (error) {
				console.error('Error on upload files >>>>', error);
			}
		},
		async processFilesUpload(index, fileData, invoiceID) {
			if (!fileData.xid) {
				await this.saveFile(fileData, invoiceID);
				if (fileData.type === 0) {
					this.filesToPassThroughOcr.push({ invoiceID: invoiceID, name: fileData.file.name, xid: fileData.xid, fileIndex: index });
				} else {
					fileData.processed = true;
				}
			}
		},
		async passFileThroughOcr(filesToPass) {
			try {
				const docXids = filesToPass.map((x) => x.xid);
				const ocrResult = await passExpenseToOcr(docXids, this.isWithDetails);
				ocrResult.forEach((x) => {
					const ocrXid = x.documents[0].xid;
					const filePassed = filesToPass.find((file) => file.xid === ocrXid);
					this.tempInvoicesFromOcr.push({ ...x, id: +filePassed.invoiceID });
				});
			} catch (error) {
				console.error('Error on passing file through OCR >>>>', error);
				this.$bvModal.msgBoxOk(
					this.FormMSG(
						55,
						'The OCR encounter some problems when reading your documents, some of the data may be corrupted...if you are not shure to continue the action, please cancel your current session and retry it again. Thanks.'
					),
					{
						title: this.FormMSG(25, 'Error'),
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'light',
						okTitle: this.dialogMsg.btnClose,
						titleClass: 'text-danger',
						headerClass: 'p-2 border-bottom-0',
						footerClass: 'p-2 border-top-0',
						class: 'text-danger',
						centered: true
					}
				);
			}
		},
		correctOcrAmounts(amount, vat, vatCode) {
			let correctVat = _.round(parseFloat(vat), 2);

			// verify vat value.
			if (!_.isNil(vatCode)) {
				const calculateVat = _.round(parseFloat(vatCode / 100) * parseFloat(amount), 2);
				if (calculateVat !== correctVat) correctVat = calculateVat;
			}

			// verify amountTotal value.
			const correctAmountTotal = _.round(parseFloat(amount), 2) + correctVat;
			return { amountVat: correctVat, amountTotal: correctAmountTotal };
		},
		provideItems(ocr) {
			if (ocr) {
				return ocr.expenseItem.map((item) => {
					const vatFactor = item.projectFlagItems.taxeFlags.length > 0 ? item.projectFlagItems.taxeFlags[0].factor : null;
					const { amountVat, amountTotal } = this.correctOcrAmounts(item.amount, item.amountVat, vatFactor);
					return {
						...item,
						date: ocr.date ? ocr.date : new Date(),
						type: EXPENSE_TYPE.INVOICE,
						amountVat: amountVat,
						amountTotal: amountTotal,
						poId: item.poId ? item.poId : null,
						poItemId: item.poItemId ? item.poItemId : null,
						category: 0,
						costCenter: 'UNDEFINED',
						categoryName: 'UNDEFINED',
						action: item.action,
						projectFlagItems: { customFlags: item.projectFlagItems.taxeFlags, taxeFlags: item.projectFlagItems.taxeFlags },
						carbon: INIT_DATA_CARBON
					};
				});
			} else return null;
		},
		mergeDescriptions(ocr, current) {
			if (ocr.description) {
				return ocr.description;
			} else {
				return current.expenseItem.map((item) => item.description).join(', ');
			}
		},
		mergeInvoiceAmountTotal(ocrAmountTotal, ocrItems) {
			let sumAmountTotalInItems = 0;
			if (ocrItems) sumAmountTotalInItems = _.round(parseFloat(ocrItems.reduce((acc, item) => acc + item.amountTotal, 0)), 2);
			const formattedAmountTotal = _.round(parseFloat(ocrAmountTotal), 2);
			if (formattedAmountTotal !== sumAmountTotalInItems) {
				return sumAmountTotalInItems;
			} else {
				return formattedAmountTotal;
			}
		},
		provideInvoiceSupplierId(ocr, current) {
			if (ocr.supplierId) {
				return ocr.supplierId;
			} else if (current.selectedPo.length > 0) {
				return current.selectedPo[0].supplierId;
			} else return current.supplierId;
		},
		provideInvoiceSupplierName(ocr, current) {
			if (ocr.supplierName) {
				return ocr.supplierName;
			} else if (current.selectedPo.length > 0) {
				return current.selectedPo[0].supplierName;
			} else return current.supplierName;
		},
		provideUserToEncodeData(id) {
			let user = this.userList.find((user) => +user.id === +id);
			if (user && user.department !== 0) {
				return {
					department: user.department,
					user: {
						id: user.id,
						name: user.name,
						firstName: user.firstName
					}
				};
			} else return null;
		},
		async mergeInvoiceDataWithOcrResult(toRefund, isForEfc = false) {
			for (const invoice of this.invoices) {
				const invoiceFoundInOcr = this.tempInvoicesFromOcr.find((x) => +x.id === +invoice.id);
				const invoiceItemsInOcr = this.provideItems(invoiceFoundInOcr);
				if (invoiceFoundInOcr) {
					invoice.date = invoiceFoundInOcr.date ? invoiceFoundInOcr.date : invoice.date;
					invoice.invoiceNumber = invoiceFoundInOcr.invoiceNumber ? invoiceFoundInOcr.invoiceNumber : invoice.invoiceNumber;
					invoice.toRefund = toRefund;
					invoice.description = this.mergeDescriptions(invoiceFoundInOcr, invoice);
					invoice.detailedDescription = invoiceFoundInOcr.detailedDescription;
					invoice.amountTotal = this.mergeInvoiceAmountTotal(invoiceFoundInOcr.amountTotal, invoiceItemsInOcr);
					invoice.department = invoiceFoundInOcr.department ? invoiceFoundInOcr.department : invoice.department;
					invoice.supplierId = this.provideInvoiceSupplierId(invoiceFoundInOcr, invoice);
					invoice.supplierName = this.provideInvoiceSupplierName(invoiceFoundInOcr, invoice);
					invoice.expenseItem = invoiceItemsInOcr;
					invoice.purchaseOrders = this.isWithDetails ? invoiceFoundInOcr.purchaseOrders : [];
					invoice.selectedPo =
						invoiceFoundInOcr.purchaseOrders.length > 0 && this.isWithDetails
							? invoiceFoundInOcr.purchaseOrders.map((x) => {
									return { ...x, id: +x.id };
							  })
							: invoice.selectedPo;
					invoice.tempFilesData = _.cloneDeep(invoice.filesData);
					invoice.itemsMerged = !this.isWithDetails;
				}
				if (isForEfc && this.userToEncodedId) {
					const userData = this.provideUserToEncodeData(this.userToEncodedId);
					if (userData) {
						invoice.department = userData.department;
						invoice.user = _.cloneDeep(userData.user);
					}
				}
			}

			const invoiceNumbers = this.invoices.map((x) => x.invoiceNumber);
			let params = {
				legalEntitySupplierId: null,
				type: EXPENSE_TYPE.INVOICE,
				subType: null,
				additionalSubType: null,
				arrayType: [],
				flagIds: [],
				recordOffSet: null,
				recordLimit: null,
				keyWord: '',
				references: invoiceNumbers
			};
			this.duplicatedInvoices = await getProjectUserExpenseSheet(params);
			if (this.duplicatedInvoices.length > 0) {
				this.invoiceDuplicatedAlertMsg = this.FormMSG(72, 'DUPLICATE ENTRY: It seems like similar data has already been used in another entry.');
				this.showInvoiceDuplicatedAlert = true;
			}
			this.tempInvoicesFromOcr = [];
		},
		async onAddFiles(filesData, toRefund, isForEfc = false) {
			// arrange files data.
			this.filesUploadInProgress = true;
			this.filesToPassThroughOcr = [];
			this.fillCurrentProcessFiles(filesData);
			for (const [index, data] of this.currentProcessFiles.entries()) {
				if (!data.processed) {
					const newInvoice = await this.createInvoice();
					if (newInvoice) {
						await this.processFilesUpload(index, data, newInvoice.id);
						this.invoices.push({ ...INVOICE_DATA_STRUCT, ...newInvoice, filesData: [data] });
					} else {
						this.createToastForMobile(
							this.FormMSG(47, 'Error'),
							this.FormMSG(54, 'You are not allowed to create an invoice outside of your contract date'),
							'',
							'danger'
						);
						this.currentProcessFiles.splice(index, 1);
					}
				}
			}

			if (this.filesToPassThroughOcr.length > 0) {
				try {
					// then pass all needed files to OCR.
					await this.passFileThroughOcr(this.filesToPassThroughOcr);
				} catch (error) {
					console.log('Error Processing FIles to upload >>>>', error);
				} finally {
					// then finally, merge all data from OCR inside the invoices table.
					this.mergeInvoiceDataWithOcrResult(toRefund, isForEfc);
					// And, change all remaining file process status to TRUE.
					const IndexProcessedList = this.filesToPassThroughOcr.map((x) => x.fileIndex);
					IndexProcessedList.forEach((i) => (this.currentProcessFiles[i].processed = true));
					this.filesToPassThroughOcr = [];
					this.filesUploadInProgress = false;
				}
			} else {
				this.filesUploadInProgress = false;
			}
		},
		cleanAndNormalizeString(inputString) {
			// Remove non-word characters and convert to lowercase
			return inputString
				.normalize('NFD')
				.replace(/[^\p{L}\p{N}\s]/gu, '') // Matches any character that is not a letter (\p{L}), digit (\p{N}), or whitespace (\s)
				.toLowerCase()
				.split(/\s+/);
		},
		countTotalMatchingElements(arrayOfArrays, singleArray) {
			return arrayOfArrays.map((subArray) => subArray.filter((item) => singleArray.includes(item)).length);
		},
		tooltipInvoiceOutsideContract() {
			let message = `${this.FormMSG(888, "This invoice is on a date outside the user's contract dates. You can still validate it.")}`;
			return message;
		},
		openNewWindowTab(link) {
			const windowFeatures = `menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=600,height=800`;
			const newWindow = window.open(link, '_blank', windowFeatures);
			if (newWindow) {
				// If the window was successfully created
				newWindow.focus(); // Focus the new window
			} else {
				// If the window was blocked by a popup blocker
				alert('Please allow popups for this website');
			}
		},
		async getProjectCustomFlags() {
			try {
				const projectFlags = await getProjectFlags();
				return projectFlags.customFlags;
			} catch (error) {
				console.log({ error });
				return null;
			}
		},
		provideInvoiceImage(filesData, invoicesImageList, invoiceImageUrls, toConcat = false) {
			let newImageList = [];
			let newImageUrls = [];
			if (filesData.length > 0) {
				if (invoicesImageList.length > 0 && toConcat) {
					newImageList = [...invoicesImageList, ...filesData];
					newImageUrls = [
						...invoiceImageUrls,
						...filesData.map((item) => {
							return item.xid + '.' + item.extension;
						})
					];
				} else {
					newImageList = filesData;
					newImageUrls = filesData.map((item) => {
						return item.xid + '.' + item.extension;
					});
				}
			} else {
				newImageList = [];
				newImageUrls = [];
			}

			return { images: newImageList, imagesUrls: newImageUrls };
		},
		providePoImage(purchaceOrder, poImageUrls, toConcat = false) {
			let newPoImagesList = [];
			if (purchaceOrder && purchaceOrder.length > 0) {
				let isNotEmpty = false;
				for (const po of purchaceOrder) {
					if (!_.isNil(po.documents) && po.documents.length > 0) {
						if (poImageUrls.length > 0 && toConcat) {
							newPoImagesList = [
								...poImageUrls,
								...newPoImagesList,
								...po.documents.map((item) => {
									return item.xid + '.' + item.ext;
								})
							];
						} else {
							newPoImagesList = [
								...newPoImagesList,
								...po.documents.map((item) => {
									return item.xid + '.' + item.ext;
								})
							];
						}
						isNotEmpty = true;
					} else {
						if (!isNotEmpty) {
							newPoImagesList = [];
						}
					}
				}
			} else {
				newPoImagesList = [];
			}

			return newPoImagesList;
		},
		indexOfInvoiceFile(file, invoiceImageUrls) {
			const fileToRemove = file.xid + '.' + file.extension;
			const index = invoiceImageUrls.findIndex((fileUrl) => fileUrl === fileToRemove);
			return index;
		},
		removeAdditionalInvoiceFile(file) {
			if (this.$refs && this.$refs.dialogInvoiceDetails)
				this.$refs.dialogInvoiceDetails.invoiceImageUrls.splice(this.indexOfInvoiceFile(file, this.$refs.dialogInvoiceDetails.invoiceImageUrls), 1);
		},
		populateInvoiceItemsDetails(items) {
			return items.map((x) => {
				return {
					...x,
					projectFlagItems: {
						customFlags: [...x.projectFlagItems.customFlags, ...x.projectFlagItems.taxeFlags],
						taxeFlags: x.projectFlagItems.taxeFlags
					},
					type: EXPENSE_TYPE.INVOICE,
					action: INVOICE_ITEMS_ACTION.SUBSTRACT,
					expenseItemId: x.id ? +x.id : null
				};
			});
		},
		checkIfHasAttachement(original, copy) {
			if (!_.isNil(original)) {
				if (original.length > 0) {
					return original;
				}
			}
			if (!_.isNil(copy)) {
				if (copy.length > 0) {
					return copy;
				}
			}
			return [];
		},
		showInvoiceDetails(invoiceData, canEdit, isNewProcess = false, isForSingle = true, reviewMode = false, isForEfc = false) {
			this.isSavedOnce = false;
			if (this.$refs && this.$refs.dialogInvoiceDetails) {
				this.$refs.dialogInvoiceDetails.initializeCarousel();
				this.$refs.dialogInvoiceDetails.isReviewMode = reviewMode;
			}
			this.isNewProcess = isNewProcess;
			this.canEditFinalForm = canEdit;
			this.selectedInvoice = _.cloneDeep(invoiceData);
			let filesData = [];
			if (!isNewProcess && isForEfc) this.userToEncodedId = +invoiceData.user.id;
			if (invoiceData.documents && invoiceData.documents.length > 0) {
				filesData = invoiceData.documents.map((x) => {
					return {
						file: {
							name: x.originalFileName
						},
						extension: x.ext,
						type: x.additionalDocumentType,
						xid: x.xid
					};
				});
			}
			this.currentInvoice = {
				...this.currentInvoice,
				...invoiceData,
				expenseItem: this.populateInvoiceItemsDetails(invoiceData.expenseItem),
				filesData: this.checkIfHasAttachement(filesData, invoiceData.filesData),
				tempFilesData: []
			};
			// provide invoices files for the viewer
			this.setViewerInvoicesImages(this.currentInvoice.filesData);
			// provide po files for the viewer from invoiceToolsMixin
			if (this.$refs && this.$refs.dialogInvoiceDetails) {
				this.$refs.dialogInvoiceDetails.poImageUrls = this.providePoImage(
					this.currentInvoice.purchaseOrders,
					this.$refs.dialogInvoiceDetails.poImageUrls
				);
			}

			this.switchFinalForm(isForSingle, isNewProcess, reviewMode);
		},
		async openReviewMode(invoices, newProcess, isForEfc = false) {
			this.isReviewModeLoading = true;
			this.invoicesToReview = _.cloneDeep(invoices);
			this.currentIndexToReview = 0;
			const firstInvoice = await this.preprareDetailsPayload(invoices[0], isForEfc);
			this.showInvoiceDetails(firstInvoice, this.canEditInvoice, newProcess, false, true, isForEfc);
			this.isReviewModeLoading = false;
		},
		async onPrevOrNext(isNext, isForEfc = false) {
			const loadingAction = async () => {
				isNext ? this.currentIndexToReview++ : this.currentIndexToReview--;
				const currentInvoiceToReview = await this.preprareDetailsPayload(this.invoicesToReview[this.currentIndexToReview], isForEfc);
				this.showInvoiceDetails(currentInvoiceToReview, this.canEditInvoice, this.isNewProcess, false, true, isForEfc);
			};
			await this.showLoader(loadingAction, 'default-container', false);
		},
		async deleteLineItemsRow(item, index) {
			this.currentInvoice.expenseItem.splice(index, 1);
			this.currentInvoice.amountTotal -= item.amountTotal;
			try {
				if (item.id && item.id != '0') await deleteExpenseItem(+item.id);
				if (this.currentInvoice.expenseItem.length === 0) {
					if (this.isForSingle) {
						if (this.isNewProcess) await deleteMyExpense(this.currentInvoice.id);
						this.handleFinsihCloseOrCancelProcess('finish');
					} else {
						// update data inside the invoices table.
						const indexOfDeleted = this.invoices.findIndex((x) => +x.id === +this.currentInvoice.id);
						this.invoices.splice(indexOfDeleted, 1);
						if (this.invoices.length > 0) {
							this.switchMultipleInvoice();
						} else {
							this.handleFinsihCloseOrCancelProcess('finish');
						}
					}
				}
			} catch (error) {
				console.log('Error on delete line item', error);
			}
		},
		moveToDraft(activeValue, canSeeApprove) {
			if (canSeeApprove) {
				if (this.tabs.activeTabs !== activeValue) {
					this.tabs.activeTabs = activeValue;
				}
			} else {
				if (this.tabs.activeTabs !== 0) {
					this.tabs.activeTabs = 0;
				}
			}

			this.draftDataKey++;
		},
		triggerHideModalEvent(isForEfc = false) {
			if (this.$refs && this.$refs.dialogInvoiceDetails) {
				this.$refs.dialogInvoiceDetails.showDialog = false;
				this.$refs.dialogInvoiceDetails.isReviewMode = false;
			}
			this.showDragAndDropDialogProcess(false, isForEfc);
		},
		async cancelProcess(isForEfc = false) {
			if (this.$refs && this.$refs.invoiceFinalForm) await this.$refs.invoiceFinalForm.deleteTempFiles();
			if (this.isNewProcess && this.invoices.length > 0) {
				const invoiceIds = this.invoices.map((x) => +x.id);
				try {
					await deleteExpenses(invoiceIds);
				} catch (error) {
					console.log('Error on cancel Process >>>>', error);
				}
			}
			this.showDeleteWarning = false;
			this.triggerHideModalEvent(isForEfc);
		},
		finishProcess(isForEfc = false) {
			this.triggerHideModalEvent(isForEfc);
			if (this.isNewProcess) {
				isForEfc ? this.moveToDraft(0, false) : this.moveToDraft(1, this.canSeeApprove);
			} else {
				this.$bus.$emit('invoice:reload-data');
			}
		},
		closeProcess(isForEfc = false) {
			if (this.isForSingle) {
				if (!this.isSavedOnce && !this.$refs.dialogInvoiceDetails.isReviewMode && (this.isNewProcess || this.canEditFinalForm)) {
					this.showDeleteWarning = true;
				} else {
					if (this.isSavedOnce) {
						this.$bus.$emit('invoice:reload-data');
						this.isSavedOnce = false;
					}
					this.triggerHideModalEvent(isForEfc);
				}
			} else {
				this.switchMultipleInvoice();
			}
		},
		/**
		 * method used for all invoicesForm actions that trigger the close/hide events.
		 * @param process cancel|finsih|close|reject|approve
		 * @param isForEfc
		 */
		async handleFinsihCloseOrCancelProcess(process, isForEfc = false) {
			this.selectedInvoice = [];
			this.finalInvoicePayload = {};
			this.invoicesToReview = [];
			this.currentIndexToReview = 0;
			this.$refs.dialogInvoiceDetails.showFormError = false;

			if (process === 'cancel') {
				await this.cancelProcess(isForEfc);
			} else if (process === 'finish') {
				this.finishProcess(isForEfc);
			} else if (process === 'close') {
				this.closeProcess(isForEfc);
			} else {
				this.triggerHideModalEvent(isForEfc);
			}
		},
		closeDragAndDropDialog(isForEfc = false) {
			if (this.isNewProcess || this.canEditFinalForm) {
				this.showDeleteWarning = true;
			} else {
				this.showDragAndDropDialogProcess(false, isForEfc);
			}
		},
		closeMultipleInvoice(isForEfc = false) {
			this.showDragAndDropDialogProcess(false, isForEfc);
			this.openMultipleInvoiceDialog = false;
			isForEfc ? this.moveToDraft(0, false) : this.moveToDraft(1, this.canSeeApprove);
		},
		expenseRerpotOnClosed() {
			this.isScriptExpenseReportOpen = false;
			this.emitLoading(false);
		},
		emitLoading(value) {
			this.$emit('budget-gl:loading', value);
		},
		handleLoading(payload) {
			if (payload) {
				this.emitLoading(false);
			}
		},
		async manageExpenseReport(subjectId, script = { id: 0, fileName: null, ext: 'xlsx' }, sendEmail = false) {
			let fileName = this.getFileNameScript(FILENAME_REPORT.REPORT_EXPENSE, script.id, script.fileName);
			try {
				const result = await expenseReport({ subjectId, sendEmail }, script.id);
				if (!sendEmail) {
					await this.forceDownload(result, fileName + '.' + script.ext);
				}
			} catch (error) {
				console.log('Error manage Expense Report >>>>>>>>>', error);
				this.createToastForMobile(this.FormMSG(703, 'Error'), this.FormMSG(704, 'Error request'), '', 'danger');
			}
		},
		async downloadXlsInvoice(currentInvoice) {
			this.isLoadingDownloadInvoice = true;
			this.scriptsInvoice = await getScripts(store.getCurrentProjectConfig().licenseID, store.getCurrentProjectConfig().id, this.scriptTypeId, true);

			if (this.scriptsInvoice.length === 0) {
				await this.manageExpenseReport(+currentInvoice.id).finally(() => {
					this.isLoadingDownloadInvoice = false;
				});
			} else if (this.scriptsInvoice.length === 1) {
				await this.manageExpenseReport(+currentInvoice.id, {
					id: this.scriptsInvoice[0].id,
					fileName: this.scriptsInvoice[0].customExportFileName,
					ext: this.getExtensionScript(
						OUTPUT_FORMAT_EXPORT.at(this.scriptsInvoice[0].outputFileFormat),
						this.scriptsInvoice[0].customExtension,
						getFileExtension(this.scriptsInvoice[0].fileName)
					)
				}).finally(() => {
					this.isLoadingDownloadInvoice = false;
				});
			} else {
				this.isLoadingDownloadInvoice = false;
				this.isScriptExpenseReportOpen = true;
				this.customReport = {
					subjectId: +currentInvoice.id,
					sendEmail: false
				};
			}
		},
		async sendXlsInvoiceByEmail(currentInvoice) {
			this.isLoadingSendMailInvoice = true;
			this.scriptsInvoice = await getScripts(store.getCurrentProjectConfig().licenseID, store.getCurrentProjectConfig().id, this.scriptTypeId, true);

			if (this.scriptsInvoice.length === 0) {
				await this.manageExpenseReport(+currentInvoice.id, 0, true).then(() => {
					this.createToastForMobile(this.FormMSG(700, 'Success'), this.FormMSG(288, 'The document has been sent to your email address.'));
				});
			} else if (this.scriptsInvoice.length === 1) {
				await this.manageExpenseReport(+currentInvoice.id, { id: this.scriptsInvoice[0].id }, true).then(() => {
					this.createToastForMobile(this.FormMSG(700, 'Success'), this.FormMSG(288, 'The document has been sent to your email address.'));
				});
			} else {
				this.isScriptExpenseReportOpen = true;
				this.customReport = {
					subjectId: +currentInvoice.id,
					sendEmail: true
				};
			}
			this.isLoadingSendMailInvoice = false;
		},
		async downloadCertifiedInvoice(currentInvoice, sendMail = false) {
			try {
				this.isLoadingCertifiedDownloadInvoice = true;
				const resultFile = await expenseDematerializationReport(+currentInvoice.id, sendMail);

				if (!sendMail) {
					const url = process.env.VUE_APP_GQL + '/images/' + resultFile;
					axios.get(url, { responseType: 'blob' }).then((response) => {
						const link = window.URL.createObjectURL(new Blob([response.data]));
						const anchor = document.createElement('a');
						anchor.setAttribute('href', link);
						anchor.setAttribute('target', '_blank');
						anchor.setAttribute('download', resultFile);
						document.body.appendChild(anchor);
						anchor.click();
						document.body.removeChild(anchor);

						this.isLoadingCertifiedDownloadInvoice = false;
					});
				} else {
					this.isLoadingCertifiedDownloadInvoice = false;
					this.createToastForMobile(this.FormMSG(700, 'Success'), this.FormMSG(288, 'The document has been sent to your email address.'));
				}
			} catch (e) {
				this.isLoadingCertifiedDownloadInvoice = false;
				this.createToastForMobile(this.FormMSG(701, 'Error'), this.resolveGqlError(e), '', 'danger');
			}
		},
		async getScriptList() {
			this.scriptsInvoice = await getScripts(store.getCurrentProjectConfig().licenseID, store.getCurrentProjectConfig().id, this.scriptTypeId, true);
		},
		flattenDocumentList(items) {
			return items.reduce((acc, obj) => {
				if (obj.documents && Array.isArray(obj.documents)) {
					acc.push(...obj.documents);
				}
				return acc;
			}, []);
		},
		async preprareDetailsPayload(invoice, isForEfc = false) {
			if (isForEfc) {
				const fullInvoiceData = await getSpecificExpense(+invoice.id);
				const itemsDoc = this.flattenDocumentList(fullInvoiceData.expenseItem);
				const invoicePayload = {
					...fullInvoiceData,
					selectedPo: fullInvoiceData.purchaseOrders,
					documents: [...fullInvoiceData.documents, ...itemsDoc],
					expenseItem: fullInvoiceData.expenseItem.map((item) => {
						return {
							..._.omit(item, ['documents', 'filesData', 'selectedPo', 'user']),
							carbon: {
								...item.carbon,
								carbonId: parseInt(item.carbon.id, 10)
							}
						};
					})
				};
				return invoicePayload;
			} else {
				const registeredItems = await getInvoicesItems(+invoice.id);
				const itemsDoc = this.flattenDocumentList(registeredItems);
				const invoicePayload = {
					...invoice,
					selectedPo: invoice.purchaseOrders,
					documents: [...invoice.documents, ...itemsDoc],
					expenseItem: registeredItems.map((item) => {
						return {
							..._.omit(item, ['documents', 'filesData', 'selectedPo', 'user']),
							carbon: {
								...item.carbon,
								carbonId: parseInt(item.carbon.id, 10)
							}
						};
					})
				};
				return invoicePayload;
			}
		}
	}
};
